<template>
  <v-card
      :loading="isLoadingBt"
      elevation="0"
      class="card-border-10"
  >
    <b-row align-v="center" style="margin-bottom: 2rem; margin-top: 1rem">
      <b-col cols="1">
        <a class="custom-back justify-start" @click="onGoBack">
          <b-img
              :src="
                            require('../../../assets/images/ic-arrow-left.svg')
                        "
          />
        </a>
      </b-col>
      <b-col>
        <b-card-text class="form-title">
          {{ enterOtpCode }}
        </b-card-text>
      </b-col>
    </b-row>
    <b-card-text class="font-lg"> {{ noteReceiveOtp }}</b-card-text>
    <b-card-text class="font-lg"> {{ accountReceiveOtp }}</b-card-text>
    <v-container>
      <v-sheet width="75%" class="mx-auto mt-2" max-width="70%">
        <v-otp-input
            v-model="otpValue"
            :error="otpError"
            placeholder="_"
            length="6"
            type="number"
        >
        </v-otp-input>
      </v-sheet>
      <div class="text-body-1 text-valid-error">{{ otpError ? otpErrorMessage : '' }}</div>
    </v-container>
    <b-row class="custom-button">
      <b-col>
        <b-button
            v-if="!isLoadingBt"
            variant="primary"
            class="custom-submit"
            :disabled="btSendDisabled"
            @click="onConfirmOtp"
        >
          {{ confirm }}
        </b-button>
        <b-button
            v-else
            variant="primary"
            class="custom-submit"
            :disabled="btSendDisabled"
        >
          <b-spinner small type="grow"/>
          {{ confirm }}
        </b-button>
      </b-col>
    </b-row>
    <div class="text-body-1 text-center mt-5 px-6">
      {{ $t("ui.receiveOtp") }}
      <v-btn
          elevation="0"
          class="no-uppercase btn-custom ml-1 pb-1"
          :disabled="isDisabled"
          @click="handleResendOtp"
      > {{ $t("ui.resendOtp") }}
      </v-btn>
    </div>
  </v-card>

</template>

<script>
import i18n from "../../../lang/i18n";
import {mapState} from "vuex";
import {API2, url} from "../../../api";
import routes from "../../../routes";
import path from "../../../routes/path";
import mixin from "../../../mixin";

export default {
  mixins: [mixin],
  props: {
    gotoLoginTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      otpValue: "",
      otpError: false,
      otpErrorMessage: '',
      otpTemp: "",
      isLoadingBt: false,
      countdown: 0,
      isDisabled: false
    };
  },
  computed: {
    noteReceiveOtp: () => i18n.t("ui.noteReceiveOtp"),
    enterOtpCode: () => i18n.t("ui.enterOtpCode"),
    confirm: () => i18n.t("ui.confirm"),
    btSendDisabled: function () {
      let otpNotChanged = this.otpValue === this.otpTemp
      return !this.otpValue || otpNotChanged
    },
    ...mapState([
      'accountReceiveOtp',
    ]),
  },
  methods: {
    async onConfirmOtp() {

      this.otpError = false
      let res = await this.post(API2.CONFIRM_OTP, {
            otp: this.otpValue,
            email: this.accountReceiveOtp,
            fgp: 1
          }, "isLoadingBt", false
      )
      let status = res.data.status
      let error = res.data.error
      if (status !== 200) {

        this.otpError = true
        switch (error.type) {
          default:
            this.otpValue = ''
            this.otpErrorMessage = error.message
            this.otpTemp = this.otpValue
            break;
          case  "toast" :
            this.showToast('danger', i18n.t("ui.anErrorOccurred"), error.message)
            break;
          case "popup" :
            this.showOverlay('error', i18n.t("ui.processFailed"), '', i18n.t("ui.tryAgain"),
                () => {
                  routes.push(path.login)
                })
            break;
        }
      } else {

        this.gotoLoginTab(3, this.otpValue)
      }
    },
    startCountdown() {
      this.isDisabled = true
      this.countdown = 60
      let timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.isDisabled = false;
          clearInterval(timer);
        }
      }, 1000);
    },
    async handleResendOtp() {
      let res = await this.post(API2.SEND_OTP, {
        email: this.accountReceiveOtp,
        fgp: 1
      }, "loading");
      this.startCountdown()
    },
    onGoBack() {
      this.gotoLoginTab(1)
    },
  }

}
</script>

<style scoped>

.custom-button {
  margin-top: 2rem;
}

.custom-submit:hover {
  background-color: #40A9FF;
  border-color: #40A9FF;
  color: #ffffff;
}

.custom-submit:disabled {
  background-color: #F5F5F5;
  border-color: #D9D9D9;
  color: #00000040;
}

.custom-submit {
  border-radius: 3px;
  background-color: #1890FF;
  width: 100%;
  color: #ffffff;
  margin-top: 13rem;
}

.form-title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}

.btn-custom {
  background-color: #FFFFFF !important;
  color: #1890FF !important;
  font-weight: normal !important;
  font-size: 15px !important;
}

.text-valid-error {
  min-height: 24px;
  margin-top: -8px;
  text-align: center;
  color: #FF4D4F;
}

</style>